module.exports = __webpack_public_path__ + "img/position_pro_img2.a8786fe9.png";